export default __webpack_public_path__ + "static/media/dwg-team.8a7b1e5c.png";